import {get,post} from '../utils/request';

// 通过项目查询最新赛事
export const getNewByProject = params=>get('/match/info/getNewByProject',params);
// 保存赛事
export const addSign = params=>post('/match/sign/add',params);
// 修改赛事
export const updateSign = params=>post('/match/sign/update',params);
// 学校查询报名详情
export const getSignDetailBySchool = params => get('/match/sign/detailBySchool',params);
// 学校审核赛事报名
export const schoolAudit = params => post('/match/sign/schoolAudit',params);
// 分会查询报名列表
export const signList = params => get('/match/sign/list',params);
// 分会查询报名详情
export const signDetail = params =>get('/match/sign/detail',params);
// 学校查询报名列表
export const getSignListBySchool = params => get('/match/sign/getSignListBySchool',params);